<template>
    <div class="live-country">
        <div class="region-selector-content w-100">
            <div class="form-group m-0">
                <span class="error-input-container dropdown-with-info-container" v-if="regions">
                    <button class="dropdown-with-info-container--toggle whitespace-nowrap" v-if="selectedRegion">
                        <span class="color-back">{{ selectedRegion.name }}</span>
                    </button>

                    <select class="form-control" v-model="selectedRegionIso" @change="changeRegion">
                        <option :value="region.iso" v-for="(region) in regions">{{ region.name }}</option>
                    </select>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import cookiesEnum from "@/core/constants/cookiesEnum";
import {getCookie, removeCookie, setCookie} from "@/core/utils/helpers/cookieHelper";
import {regionIsoEnum} from "@/core/constants/regionIsoEnum";

const data = () => {
    return {
        store: $store,
        selectedRegionIso: regionIsoEnum.GERMANY,
    }
}

function created() {
    const regionPath = process.env.MIX_REGION_PATH

    if (regionPath) {
        this.selectedRegionIso = regionPath;
    }
}

async function changeRegion() {
    await to(api.locale.change(this.selectedRegionIso));
    setCookie(cookiesEnum.REDIRECT_TO_REGION, this.selectedRegionIso);
    removeCookie(cookiesEnum.IGNORE_REGION_REDIRECT);
    const preFix = this.selectedRegionIso === 'de' ? '' : `/${this.selectedRegionIso}`;
    window.location.href = `${preFix}${this.postFixPath}`;
}

export default {
    data,
    created,
    props: [
      'postFixPath'
    ],
    computed: {
        ...mapState(['translate']),
        regions() {
            return [
                {name: _.get(this,'translate.home.liveInAustria'), iso: regionIsoEnum.AUSTRIA},
                {name: _.get(this,'translate.home.liveInAustralia'), iso: regionIsoEnum.AUSTRALIA},
                {name: _.get(this,'translate.home.liveInGermany'), iso: regionIsoEnum.GERMANY},
                {name: _.get(this,'translate.home.liveInItaly'), iso: regionIsoEnum.ITALY},
                {name: _.get(this,'translate.home.liveInUnitedKingdom'), iso: regionIsoEnum.UNITED_KINGDOM},
            ];
        },
        selectedRegion(){
            return this.regions.find(r => r.iso === this.selectedRegionIso)
        }
    },
    methods: {
        changeRegion,
    },
}
</script>
